const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.interceptors.request.use(function(config) {
  config.headers.Authorization = localStorage.getItem("Token") || "";
  config.headers.Lang =
    localStorage.getItem("setlanguage") ||
    localStorage.getItem("detectedLanguage") ||
    "en";
  return config;
});
const state = {
  articles: [],
};
const getters = {
  getArticles: (state) => state.articles,
};
const mutations = {};
const actions = {
  GET_FRONTPAGE({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      let size = articleData.size;
      let from = articleData.from;
      delete articleData.from;
      delete articleData.size;
      axios
        .post(`/frontpage?size=${size}&from=${from}`, articleData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log({ err });
          reject(err);
        });
    });
  },
  GET_FRONTPAGENA({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      let size = articleData.size;
      let from = articleData.from;
      delete articleData.from;
      delete articleData.size;
      axios
        .post(`/frontpage/na?size=${size}&from=${from}`, articleData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log({ err });
          reject(err);
        });
    });
  },
  GET_PUBLIC_ARTICLE({ commit }, articleId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `article/${articleId}/${localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en"}`
        )
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log({ err });
          reject(err);
        });
    });
  },
  POST_COMMENT({ commit }, commentData) {
    return new Promise((resolve, reject) => {
      axios
        .post("commentarticle", {
          Articles_id: commentData.Articles_id,
          Content: commentData.Content,
          ArticleComments_id: commentData.ArticleComments_id || null,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  POST_REPORT({ commit }, REPORTDATA) {
    return new Promise((resolve, reject) => {
      axios
        .post("report", REPORTDATA)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
